module.exports = __webpack_public_path__ + "PeBN-nJUPb_WsGYCw/search.png";